import React, { useRef, useState } from "react";
import useOnClickOutside from "use-onclickoutside";
import styled from "styled-components";

const Wrapper = styled.div`
  display: flex;
  position: absolute;
  top: 45px;
  left: 0px;
  padding: 20px;
  width: 280px;
  background-color: #fff;
  border-radius: 5px;

  &:before {
    content: "";
    display: block;
    position: absolute;
    top: -8px;
    right: 20px;
    border-bottom: 8px solid #fff;
    border-left: 8px solid transparent;
    border-right: 8px solid transparent;

    z-index: 1;
  }

  &:after {
    content: "";
    display: block;
    position: absolute;
    top: -13px;
    right: 18px;
    border-bottom: 10px solid #06c;
    border-left: 10px solid transparent;
    border-right: 10px solid transparent;
  }
`;

const Input = styled.input`
  flex: 1;
  font-family: "Helvetica Neue";
  font-size: 14px;
  color: #444;
  padding: 8px;
  border: 1px solid #ddd;
  border-radius: 3px;

  &:focus {
    outline: none;
  }
`;

Input.defaultProps = {
  placeholder: "Enter the URL of the link",
};

const Button = styled.button`
  margin-left: 8px;
  padding: 10px;
  border: none;
  border-radius: 5px;
  background-color: #4267b2;
  font-weight: bold;
  color: #fff;
  cursor: pointer;
`;

const LinkPrompt = ({ setOpen, submitLink, url = "" }) => {
  const [_url, setUrl] = useState(url);
  const ref = useRef();
  useOnClickOutside(ref, () => setOpen(false));

  const onSubmit = () => {
    submitLink(_url);
    setOpen(false);
  };

  return (
    <Wrapper ref={ref}>
      <Input
        autoFocus
        onKeyUp={(e) => e.code === "Enter" && onSubmit()}
        value={_url}
        onChange={(e) => setUrl(e.target.value)}
      />
      <Button onClick={() => onSubmit()}>OK</Button>
    </Wrapper>
  );
};

export default LinkPrompt;
